var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md chart"},[_c('div',{staticClass:"interval"},[_c('div',{staticClass:"proportion",style:(_vm.styleSet)},[_c('div',{staticClass:"content"},[_c('canvas',{ref:"chart",on:{"click":_vm.action}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }